import React, { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../hooks/auth/use_auth'
import { Box, CircularProgress, Typography } from '@mui/material'

interface AuthenticatedRouteProps {
  children: React.ReactNode
}

/**
 * 認証必須ルート
 * 未認証の場合はログイン画面にリダイレクト
 * 認証済みの場合は子コンポーネントを表示
 */
const AuthenticatedRoute: React.FC<AuthenticatedRouteProps> = ({
  children,
}) => {
  const { isAuthenticated, loading, initialize } = useAuth()
  const location = useLocation()

  useEffect(() => {
    // アプリ起動時に認証状態を初期化
    initialize()
  }, [initialize])

  // ローディング中は読み込み画面を表示
  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <CircularProgress size={48} />
        <Typography variant="body1" color="text.secondary">
          認証状態を確認中...
        </Typography>
      </Box>
    )
  }

  // 未認証の場合はログイン画面にリダイレクト
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // 認証済みの場合は子コンポーネントを表示
  return <>{children}</>
}

export default AuthenticatedRoute
